module.exports = __webpack_public_path__ + "img/bangaloreLight.33cf35da.png";